import { useEffect, useState } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import { useNavigate, useParams } from 'react-router-dom'
import styles from './CompanyStaffCardPageAdmin.module.css'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import ReviewsForCards from '../../components/ReviewsForCards/ReviewsForCards'
import StaffMainInformation from '../../components/StaffMainInformation/StaffMainInformation'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import {
  createStaffComment,
  deleteStaff,
  getCurrentStaff,
  getStaffComments,
} from '../../redux/actions/staffAction'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import Loader from '../../components/UI/Loader/Loader'
import PATH from '../../navigation/path'

import CustomModal from '../../components/UI/CustomModal/CustomModal'
import DeleteComponent from '../../components/DeleteComponent/DeleteComponent'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { useToast } from '../../context/ToastContext'
import { useMediaQuery } from 'react-responsive'

const CompanyStaffCardPageAdmin = () => {
  const [commentFile, setCommentFile] = useState<any>([])

  const [visible, setVisible] = useState<boolean>(false)

  const { companyId } = useParams<{ companyId: string }>()
  const { workerId } = useParams<{ workerId: string }>()
  const { showSuccess, showError } = useToast()
  const userRole = useAppSelector((state) => state.auth.userRole)
  const { currentStaff, staffComments, isLoading } = useAppSelector((state) => state.staff)
  const { token } = useAppSelector((state) => state.auth)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const postNewCommentHandler = async (text: string) => {
    const formData = new FormData()

    if (commentFile) {
      for (let i = 0; i < commentFile.length; i++) {
        formData.append('file', commentFile[i])
      }
    }

    formData.append('employeeId', String(currentStaff.id))
    formData.append('text', text)

    const resultAction = await dispatch(
      createStaffComment({
        employeeId: String(currentStaff.id),
        formData,
      }),
    )

    if (createStaffComment.rejected.match(resultAction)) {
      showError('Произошла ошибка при создании комментария')
    } else {
      showSuccess('Комментарий успешно оставлен')
      await dispatch(getStaffComments({ staffId: workerId }))
      setCommentFile([])
    }
  }

  const onDeleteStaff = async () => {
    const resultAction = await dispatch(deleteStaff({ staffId: String(currentStaff.id), token }))

    if (deleteStaff.rejected.match(resultAction)) {
      showError('Произошла ошибка при удалении сотрудника')
    } else {
      navigate(`${PATH.companyManagementStaffPage}${companyId}`)
      showSuccess('Комментарий успешно удален')
    }
  }

  const onRedirectToCompanyManagementStaffPage = () => {
    navigate(`${PATH.companyManagementStaffPageAdmin}${companyId}`)
  }

  useEffect(() => {
    dispatch(getCurrentStaff({ staffId: workerId, token }))
  }, [companyId, workerId, dispatch])

  useEffect(() => {
    if (userRole !== 'employeeAgent') {
      dispatch(getStaffComments({ staffId: workerId }))
    }
  }, [workerId, dispatch])

  if (isLoading) {
    return <Loader />
  }

  const onDeletePopup = () => {
    setVisible(true)
  }

  return (
    <div className={styles.companyStaffCardPage}>
      <CustomModal visible={visible} setVisible={setVisible}>
        <DeleteComponent
        
          title='Удаление сотрудника'
          description='Хотите удалить данного сотрудника?'
          onCancelHandler={() => setVisible(false)}
          onDeleteHandler={onDeleteStaff}
        />
      </CustomModal>
      <Navbar />
      <HeaderForCard
        deleteButton={
          <CustomButton
            iconSrc={IconTrashRed}
            className={styles.deleteBtn}
            title={isMobile ? '' : 'Удалить сотрудника'}
            onClick={onDeletePopup}
          />
        }
        title='Карточка сотрудника'
        onRedirectHandler={onRedirectToCompanyManagementStaffPage}
      />
      <div className={styles.content}>
        <StaffMainInformation staffData={currentStaff} />

        {userRole !== 'employeePlace' && userRole !== 'employeeAgent' && (
          <div className={styles.leftBlock}>
            <ReviewsForCards
              employees={currentStaff.company.employees}
              comments={staffComments}
              postNewCommentHandler={postNewCommentHandler}
              setCommentFile={setCommentFile}
            />
          </div>
        )}
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default CompanyStaffCardPageAdmin
